export enum OrderAutomationType {
  Inactive = 'inactive',
  Manual = 'manual',
  Active = 'active',
}

export enum OrderAutomationFilterTypes {
  Archive = 'archive',
  Active = 'active',
  Error = 'error',
  ErrorReviewed = 'reviewed',
  TemplateErrorHandled = 'template-error-handled',
  Spam = 'spam',
  TemplateError = 'template-error',
  Technical = 'technical',
  All = 'all',
}

export enum OrderAutomationNotificationType {
  Sms = 'sms',
  Push = 'push',
}
